import apiService from "./apiService";

const GeocercasService = {
  getGeocercas: () => apiService.get("/api/v1/geocercas"),
  createGeocerca: (geocercaData) => apiService.post("/api/v1/geocerca", geocercaData),
  getGeocercaShipmentById: (id_shipment) => apiService.get(`/api/v1/geocercas/${id_shipment}/shipments`),
  updateGeocerca: (id_geocerca, id_shipment, geojsonData) => apiService.patch(`/api/v1/geocerca/${id_geocerca}/shipment/${id_shipment}`, geojsonData),
  deleteGeocerca: (id_geocerca, id_shipment) => apiService.delete(`/api/v1/geocerca/${id_geocerca}/shipment/${id_shipment}`)

  
//   getUserById: (id) => apiService.get(`/users/${id}`),
//   createUser: (userData) => apiService.post("/users", userData),
//   updateUser: (id, userData) => apiService.put(`/users/${id}`, userData),
//   deleteUser: (id) => apiService.delete(`/users/${id}`),
};

export default GeocercasService;
